import React from 'react'
import { Intent } from '@blueprintjs/core'
import { Button } from '@ui'
import EmployeeCatalog from '../../EmployeeCatalog'
import UpdateUsageSection from './UpdateUsageSection'
import { get } from 'lodash'
import { isPrimary, isSecondary, isShared, pluralize } from '@utils'
import { IFloorMapSpace, IFullEmployee, ICatalogEmployee, IUsageType } from '@api/types'

interface EmployeeTabProps {
  assignmentPlanId: string
  space?: IFloorMapSpace
  seat: (props: { toSpaceId: string; fromSpaceId?: string; employee: ICatalogEmployee }) => void
  unseat: (employee: IFullEmployee) => void
  unseatAll: () => void
  updateSpaceUsage: (usageType: IUsageType) => void
}

export default function EmployeeTab({
  assignmentPlanId,
  space,
  seat,
  unseat,
  unseatAll,
  updateSpaceUsage,
}: EmployeeTabProps) {
  if (!space) return null

  if (isPrimary(space.usageType) || isSecondary(space.usageType) || isShared(space.usageType)) {
    const employee = get(space, 'spaceAssignment.employee')
    const sharedEmployees = get(space, 'spaceAssignment.sharedEmployees') || []

    return (
      <div style={{ margin: '-10px -5px' }}>
        {!!sharedEmployees.length && (
          <div style={{ margin: '5px' }}>
            <Button
              fill
              intent={Intent.DANGER}
              iconName="user-times"
              text={`Unseat ${sharedEmployees.length} 
              ${pluralize(sharedEmployees.length, 'employee')}`}
              onClick={unseatAll}
            />
          </div>
        )}
        {employee && (
          <div style={{ margin: '5px' }}>
            <Button
              fill
              intent={Intent.DANGER}
              iconName="user-times"
              text="Unseat"
              onClick={() => unseat(employee)}
            />
          </div>
        )}
        <div
          style={{
            height: get(space, 'spaceAssignment.employee') ? 250 : 287,
          }}
        >
          <EmployeeCatalog
            assignmentPlanId={assignmentPlanId}
            multi={isShared(space.usageType)}
            selection={sharedEmployees.map(({ id }: IFullEmployee) => id)}
            onSelect={(empl: ICatalogEmployee) => {
              if (sharedEmployees) {
                if (
                  (get(space, 'spaceAssignment.sharedEmployees') || []).find(
                    ({ id }: IFullEmployee) => id === empl.id
                  )
                ) {
                  unseat(empl)
                } else {
                  seat({
                    employee: empl,
                    toSpaceId: space.id,
                    fromSpaceId: get(employee, 'spaceAssignment.space.id'),
                  })
                }
              } else {
                const toSpaceId = space.id
                const fromSpaceId = get(employee, 'spaceAssignment.space.id')
                if (empl.id !== employee?.['id']) {
                  seat({ employee: empl, toSpaceId, fromSpaceId })
                }
              }
            }}
          />
        </div>
      </div>
    )
  }

  return (
    <UpdateUsageSection
      text="To assign employees to this space convert it to:"
      filter={(usageType) => isPrimary(usageType) || isSecondary(usageType) || isShared(usageType)}
      updateSpaceUsage={updateSpaceUsage}
    />
  )
}
